<template slot-scope="scope">
  <div class="device-list">
    <div class="device-list-tab">
      <el-table
        :data="tableData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        :empty-text="HintMsg"
        :header-cell-style="{
          background: '#409eff ',
          textAlign: 'center',
          color: '#ffffff',
          padding: '3px',
          fontSize: '12px',
          fontWeight: '400',
          height: '45px',
        }"
        :row-style="{ height: '35px' }"
      >
        <el-table-column
          label="管理者ID"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.userCode }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="管理者姓名"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.username }}</span>
          </template>
        </el-table-column>
        <el-table-column label="身份证" align="center" >
          <template slot-scope="scope">
            <span>{{ scope.row.idCard || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="联系方式" align="center" >
          <template slot-scope="scope">
            <span>{{ scope.row.phone }}</span>
          </template>
        </el-table-column>
        <el-table-column label="管理者职位" align="center" >
          <template slot-scope="scope">
            <span>{{ scope.row.positionName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="权限"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{
              scope.row.action == 0
                ? "只可看"
                : scope.row.action == 1
                ? "可操作"
                : "-"
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="状态"
          align="center"
          show-overflow-tooltip
          width="140"
        >
          <template slot-scope="scope">
            <div class="switch" @click="handelSwitch(scope.$index, scope.row)">
              <div :class="scope.row.status == 1 ? 'StatusOn' : ''"></div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="180" fixed="right">
          <template slot-scope="scope">
            <div class="table-p">
              <div
                class="dele Controls"
                @click="handelDele(scope.$index, scope.row)"
              >
                删除
              </div>
              <div
                v-if="scope.row.status == 1"
                class="EDITOR Controls"
                @click="handelEDITOR(scope.$index, scope.row)"
              >
                编辑
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <ThreeWindow
      :dialogVisible="dialogVisible"
      :PopUpTitle="PopUpTitle"
      :type="type"
      @handleCancel="handleCancel"
      @handleVerify="handleVerify"
    ></ThreeWindow>
    <ThreeEDITOR
      :dialogEDITOR="dialogEDITOR"
      :echoRow="echoRow"
      :arr="arr"
      @handleCancelEDITOR="handleCancelEDITOR"
      @handleVerifyEDITOR="handleVerifyEDITOR"
    ></ThreeEDITOR>
  </div>
</template>

<script>
import {
  changeAdminStatus, //切换管理员状态
  delAdminPermissions, //删除企业管理员
  saveOrUpdateAdminPermissions, // 添加企业管理员权限列表
  getAdminPermissions, // 查询指定管理员权限
} from "../../../../../assets/api/firm/firmCenter";
import ThreeWindow from "./ThreeWindow.vue";
import ThreeEDITOR from "./ThreeEDITOR.vue";
export default {
  props: {
    tableData: {},
    HintMsg: {}, //提示语
  },
  components: { ThreeWindow, ThreeEDITOR },
  data() {
    return {
      dialogVisible: false, //提示弹窗
      PopUpTitle: "", //提示弹窗标题
      type: "1", //提醒类型，本页只有删除 1      拒绝2  同意3
      ControlsId: "", // 操作id
      dialogEDITOR: false, //编辑权限
      echoRow: {}, // 传给编辑弹窗回显
      arr: [], //用户已有权限
    };
  },
  computed: {},
  created() {},
  methods: {
    // 权限编辑
    handelEDITOR(index, row) {
      if (!this.$checkAction()) return;
      // console.log(row, "411");
      this.echoRow = row;
      var data = {
        data: {
          id: row.bindId,
        },
      };
      getAdminPermissions(data).then((res) => {
        // console.log(res)
        // 搞出用户已有权限的页面数组
        // for (var i in res.data.permissionsGroup) {
        //   for (var k in res.data.permissionsGroup[i]) {
        //     this.arr.push(res.data.permissionsGroup[i][k].menuId);
        //   }
        // }
        this.arr = res.data.permissions.split(",");
      });
      this.dialogEDITOR = true;
    },
    // 权限编辑取消
    handleCancelEDITOR() {
      this.dialogEDITOR = !this.dialogEDITOR;
    },
    // 权限编辑确认
    handleVerifyEDITOR() {
      this.$emit("handleVerify");
      this.dialogEDITOR = !this.dialogEDITOR;
    },

    // 状态切换
    handelSwitch(index, row) {
      if (!this.$checkAction()) return;
      var data = {
        data: {
          bindId: row.bindId,
          status: row.status == "0" ? "1" : "0",
        },
      };
      changeAdminStatus(data).then((res) => {
        if (res.code == 0) {
          this.$tool.PromptBox("success", "操作成功");
          // 传给父组件刷新数据接口
          this.$emit("handleVerify");
        } else {
          // this.$tool.PromptBox("error", res.msg);
        }
      });
      // if (row.status == "1") {
      //   row.status = "0";
      // } else {
      //   row.status = "1";
      // }
    },
    // 删除
    handelDele(index, row) {
      if (!this.$checkAction()) return;
      this.$confirmWithScroll(
        "是否删除该管理者，删除后该管理者不可登录本企业后台管理系统？",
        "删除",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          var data = {
            data: {
              bindId: row.bindId,
            },
          };
          delAdminPermissions(data).then((res) => {
            if (res.code == 0) {
              this.$tool.PromptBox("success", "操作成功");
              this.$emit("handleVerify");
            }
          });
        })
        .catch(() => {});
    },
    // 删除弹窗 取消
    handleCancel() {
      this.dialogVisible = !this.dialogVisible;
    },
    // 删除弹窗确认（兼容旧弹窗）
    handleVerify() {
      var data = {
        data: {
          bindId: this.ControlsId,
        },
      };
      delAdminPermissions(data).then((res) => {
        if (res.code == 0) {
          this.$tool.PromptBox("success", "操作成功");
          // 传给父组件刷新数据接口
          this.$emit("handleVerify");
        } else {
          // this.$tool.PromptBox("error", res.msg);
        }
      });
      this.dialogVisible = !this.dialogVisible;
    },

    //表格颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "warning-row";
      } else if (rowIndex % 2 == 1) {
        return "success-row";
      }
      return "success-row";
    },
  },
};
</script>

<style scoped lang="less">
/* 主内容区滚动条样式 */
::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  height: 8px; /* 主内容区水平滚动条高度 */
}

/* 强制右侧固定列高度与主内容区相同 */
::v-deep .el-table__fixed-right {
  height: 100% !important; /* 覆盖默认高度计算 */
}
/* 滚动条滑块（可拖动部分）颜色 */
::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: #c0c0c0; /* 灰色滑块，比轨道深一些 */
  border-radius: 4px; /* 可选：滑块圆角 */
}
// 兼容火狐
::v-deep .el-table__body-wrapper {
  /* 控制滚动条粗细（对应 WebKit 的 height:8px） */
  scrollbar-width: thin; /* Firefox 中"thin"约 8px 粗细 */
  /* 控制滑块和轨道颜色（对应 WebKit 的 thumb 和 track） */
  scrollbar-color: #c0c0c0 #f5f5f5; /* 滑块色 + 轨道色 */
}
.switch {
  display: flex;
  div {
    width: 55px;
    height: 25px;
    margin: auto;
    background-image: url("../../../../../assets/imgs/weikaiqi@3x.svg");
    background-size: 100% 100%;
    border-radius: 10px;
  }
  // 开
  .StatusOn {
    background-image: url("../../../../../assets/imgs/kaiqi@3x.svg");
    background-size: 100% 100%;
  }
}
.table-p {
    display: block;
  height: 25px;
  line-height: 25px;
  font-family: PingFangSC-Medium;
  font-size: 10px;
  color: #ffffff;
  font-weight: 400;
  cursor: pointer;
  margin: auto;
  display: flex;
  justify-content: center;
  .Controls {
    width: 60px;
    height: 24px;
    border-radius: 5px;
  }
  .dele {
    background: #fe574a;
    margin-right: 10px;
    text-align: center;
  }
  .EDITOR {
    background: #409eff ;
  }
}

/deep/th:nth-child(1) {
  border-radius: 10px 0 0 0 !important;
}
/deep/th:nth-child(8) {
  border-radius: 0px 10px 0px 0px !important;
}
// /deep/th:nth-last-child(1) {
//   border-radius: 0 10px 0 0 !important;
// }

/deep/th {
  height: 45px !important;
  padding: 0;
}
/deep/ td {
  height: 40px !important;
  padding: 0;
}
.device-list-tab {
  border: 1px solid #eeeeee;
  border-radius: 10px 10px 0 0;
}
/deep/.el-table__empty-block,
/deep/.el-table tr,
/deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
  color: #333333;
  font-weight: 400;
  font-size: 12px;
}
/deep/.el-table .warning-row td {
  font-size: 12px;
  color: #333333;
}

::v-deep .el-table .warning-row td {
  background: #eeeeee !important;
}
/deep/.device-list {
  border: 1px solid goldenrod !important;
}
</style>
